import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatExpansionModule } from '@angular/material/expansion';
import { EffyCollapseComponent, EffyCollapseSize } from '@effy-tech/angular-common/collapse';
import { EffyLiseretComponent, EffyLiseretSize } from '@effy-tech/angular-common/liseret';
import { DeviceManagerService } from '../../services/device-manager/device-manager.service';
import { RichResultsService } from '../../services/rich-results/rich-results.service';
import { SchemaTypes } from '../../services/rich-results/rich-results.values';
import { RteComponent } from '../rte/rte.component';
import { TitleComponent } from '../title/title.component';
import { IFaq } from './faq';

@Component({
  selector: 'nscf-faq',
  templateUrl: 'faq.component.html',
  styleUrls: ['faq.component.scss'],
  imports: [TitleComponent, RteComponent, MatExpansionModule, EffyCollapseComponent, EffyLiseretComponent],
  host: {
    '[class]': 'hostClasses()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent implements OnInit {
  @Input() data: IFaq;
  readonly isMobileOrTablet = toSignal(inject(DeviceManagerService).isMobileOrTablet());
  readonly size = computed(() => (this.isMobileOrTablet() ? EffyCollapseSize.SMALL : EffyCollapseSize.MEDIUM));
  private readonly richResultsService = inject(RichResultsService);
  protected readonly hostClasses = computed(() => `container faq faq-${this.size()}`);
  protected readonly liseretSize = EffyLiseretSize.LARGE;

  ngOnInit(): void {
    this.richResultsService.setJsonLd(SchemaTypes.FAQ_PAGE, this.data.content);
  }
}
